import React from "react";
import { colors } from "../../constants/colors";

const Button = ({
  variant = "primary",
  size = "medium",
  children,
  className = "",
  disabled = false,
  onClick,
  ...props
}) => {
  const getStyles = () => {
    const baseStyles = {
      border: "none",
      borderRadius: "12px",
      cursor: disabled ? "not-allowed" : "pointer",
      fontFamily: "inherit",
      fontWeight: 600,
      textDecoration: "none",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
      transition: "all 0.3s ease",
      opacity: disabled ? 0.6 : 1,
    };

    const sizeStyles = {
      small: {
        padding: "8px 16px",
        fontSize: "0.875rem",
      },
      medium: {
        padding: "12px 24px",
        fontSize: "1rem",
      },
      large: {
        padding: "16px 32px",
        fontSize: "1.125rem",
      },
    };

    const variantStyles = {
      primary: {
        backgroundColor: colors.darkGreen,
        color: colors.white,
      },
      secondary: {
        backgroundColor: colors.lightGreen,
        color: colors.darkGreen,
      },
      outline: {
        backgroundColor: "transparent",
        color: colors.darkGreen,
        border: `2px solid ${colors.darkGreen}`,
      },
    };

    return {
      ...baseStyles,
      ...sizeStyles[size],
      ...variantStyles[variant],
    };
  };

  return (
    <button
      style={getStyles()}
      className={className}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
